var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatureIcon1 = function SvgFeatureIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 120,
    viewBox: "0 0 125 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.2,
    cy: 62.4,
    r: 57.6,
    fill: "#E38BB6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4,
    cy: 60,
    r: 57.6,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 57.6,
    r: 56.6,
    stroke: "#65C9DB",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0556 59.8888C54.1727 59.8888 55.8889 58.1726 55.8889 56.0555C55.8889 53.9384 54.1727 52.2222 52.0556 52.2222C49.9385 52.2222 48.2222 53.9384 48.2222 56.0555C48.2222 58.1726 49.9385 59.8888 52.0556 59.8888Z",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72.6667L71.2222 59.8889L43.1111 88",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8889 32H43.1111C40.2883 32 38 34.7858 38 38.2222V81.7778C38 85.2142 40.2883 88 43.1111 88H78.8889C81.7117 88 84 85.2142 84 81.7778V38.2222C84 34.7858 81.7117 32 78.8889 32Z",
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFeatureIcon1;